export enum EventCategory {
  BasicAccountLimit = "SwissForm - SK-Limite",
  CardLimit = "SwissForm - KA-Limite",
  CompanyNameOnCard = "SwissForm - Firmennamen auf Karte",
  CorrespondenceLanguage = "SwissForm - Korrespondenzsprache",
  ControllingOwners = "SwissForm - Kontrollinhaber",
  PartnerPlusBenefit = "SwissForm - PartnerPlusBenefit",
  CashWithdrawal = "SwissForm - Bargeldbezug",
  CardHolder = "SwissForm - Karteninhaber",
  AmericanExpress = "SwissForm - AmericanExpress",
  MilesAndMore = "SwissForm - Miles & More",
  AuthorizedRepresentative = "SwissForm - Bevolmachtige Person",
  AuthorizedSignatory = "SwissForm - Unterschriftsberechtigte Person",
  InfoByEmail = "SwissForm - Info per Email",
  NewsletterSubscription = "SwissForm - Newsletter",
  DigitalOrHandwrittenSignature = "SwissForm - Digitale oder Handschriftliche Unterschrift",
}

export enum YesNoDecisionEvent {
  Yes = "Ja",
  No = "Nein",
}

export enum SameOrOtherEvent {
  Identical = "Gleiche",
  Other = "Andere",
  None = "Keine",
}

export enum LanguageChosenEvent {
  German = "Deutsch",
  French = "Französisch",
  Italian = "Italienisch",
  English = "Englisch",
}

export const PERSON_ADDED_ACTION_VALUE = "weitere Person hinzugefügt";

export type EventActionValue =
  | YesNoDecisionEvent
  | SameOrOtherEvent
  | LanguageChosenEvent;
